/*
 * @Author: wangyunlin wangyunlin@morewis.com
 * @Date: 2022-10-17 22:25:57
 * @LastEditors: wangyunlin wangyunlin@morewis.com
 * @LastEditTime: 2023-04-27 18:43:14
 * @FilePath: \douyin\src\api\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from './axios'
const serveUrl = 'https://mvp.bxsvip.com/prod-api/bxs/fastPay';

const serveUrl2 = 'https://m.bxsvip.com/prod-api/bxs/fastPay';

const serveUrl3 = 'https://auth.dymvp.com/prod-api/bxs/fastPay';



export function getDYuserInfo(code) {
  return request({
      method: 'get',
      url: 'https://www.topuplive.com/pro-api/charge/get-avatar-info?type=douyin&account=' + code,
  })
}

// 抖音号识别
export function getAvatarInfo(account) {
  return request({
      method: 'get',
      url: serveUrl + '/getAvatarInfo?account=' + account,
  })
}

// 快手号识别
export function getAvatarInfoKs(account) {
  return request({
      method: 'get',
      url: serveUrl + '/getAvatarInfoKs?account=' + account,
  })
}

export function getAvatarInfoKs2(account) {
    return request({
        method: 'get',
        url: serveUrl2 + '/getAvatarInfoKs?account=' + account,
    })
}
// 快手号识别（官方接口，带未成年识别）

export function getKsAccoutInfo(account) {
    return request({
        method: 'get',
        url: serveUrl3 + '/getAvatarInfoKsOfficial?account=' + account,
    })
}

export function reqPayParams(data) {
  return request({
      method: 'post',
      url: serveUrl + '/charge',
      data,
  })
}
export function reqPayParams2(data) {
  return request({
      method: 'post',
      url: serveUrl2 + '/charge',
      data,
  })
}

// 获取用户积分
export function userpPoint(data) {
  return request({
      method: 'get',
      url: serveUrl + '/getPoints',
      params: data
  })
}

// 每日签到
export function signIn(data) {
  return request({
      method: 'get',
      url: serveUrl + '/singIn?authCode=' + data,
  })
}

// 抖音号识别（官方）
export function loginDy(data) {
  return request({
      method: 'get',
      url: serveUrl + '/getAvatarOfficial?account=' + data,
  })
}

// 获取微信授权code
export function wxAuthCode(data) {
    return request({
        method: 'get',
        url: serveUrl + '/getAuthCode?' + data,
    })
}
// 获取微信授权code
export function wxAuthCode2(data) {
    return request({
        method: 'get',
        url: serveUrl2 + '/getAuthCode?' + data,
    })
}


export function getUserOrder(data) {
    return request({
        method: 'post',
        url: serveUrl3 + '/userOrderList',
        data,
    })
}

export function sendComplaint(data) {
    return request({
        method: 'post',
        url: serveUrl3 + '/subComplaint',
        data,
    })
}
export function skuList(data) {
    return request({
        method: 'get',
        url: serveUrl3 + '/getProducts?orderType=' + data,
    })
}

export function payState(data) {
  return request({
      method: 'get',
      url: serveUrl3 + '/getOrderStatus?orderNo=' + data,
  })
}

export function getIP() {
  return request({
      method: 'get',
      url: 'https://apis.map.qq.com/ws/location/v1/ip?key=2FZBZ-VIHCQ-PUD5C-4XTAD-SUGTT-U3BMY',
  })
}

export function apPayAuto(data) {
  return request({
      method: 'get',
      url: serveUrl3 + '/checkAc?'+data,
  })
}